export default __webpack_public_path__ + "static/media/thinking.8f268d77.png";